import { render, staticRenderFns } from "./PaymentCertificate.vue?vue&type=template&id=0b121831"
import script from "./PaymentCertificate.vue?vue&type=script&lang=js"
export * from "./PaymentCertificate.vue?vue&type=script&lang=js"
import style0 from "./PaymentCertificate.vue?vue&type=style&index=0&id=0b121831&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VContainer})
